exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3j9h2{height:100vh;position:fixed;top:0;left:0;right:0;z-index:1000;background-color:hsla(0,0%,100%,.9)}@-webkit-keyframes aSyGL{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes aSyGL{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}._3j9h2 ._2qf03{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:160px;margin-top:calc(50vh - 100px)}._3j9h2 ._2qf03 .cXDY8{width:160px;height:160px;-webkit-animation:aSyGL 2s ease-in-out infinite;animation:aSyGL 2s ease-in-out infinite}._3j9h2 ._2qf03 .cXDY8 img{width:160px;height:160px;opacity:.9}._3j9h2 ._3K8ty{padding:24px 0;color:#606060;font-size:20px;text-align:center}", ""]);

// exports
exports.locals = {
	"loaderRoot": "_3j9h2",
	"spinnerContainer": "_2qf03",
	"spinner": "cXDY8",
	"spin": "aSyGL",
	"title": "_3K8ty"
};